import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export class PostSlider01 {
  constructor() {
    if (document.querySelector('.js-post_slider01') === null) return
    const sliders = document.querySelectorAll('.js-post_slider01')
    sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        grabCursor: true,
        setWrapperSize: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    })
  }
}
